<template>
  <div id="corps">
    <v-app>
      <router-view />
      <v-snackbar :value="isMockApi" color="warning" right :timeout="-1">Mock API activé.</v-snackbar>
    </v-app>
  </div>
</template>

<script>
export default {
  computed: {
    isMockApi() {
      return parseInt(process.env.VUE_APP_MOCK_API)
    }
  }
}
</script>
<style lang="scss">
#corps {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#bordered-sheet {
  border: 2px solid var(--v-primary-base);
  border-radius: 15px;
}
@media screen and (max-width: 1000px) {
  #bordered-sheet {
    border: 0;
  }
}
.list_counter_validator {
  display: none !important;
}
</style>
